export const ROLES = {
  ADMIN: 'ADMIN',
  USER: 'USER',
} as const;

export const TIPO_OPERACION_LABELS: Record<string, string> = {
  VENTA: 'Compra',
  ALQUILER: 'Alquiler',
};

export const UBICACION_LABELS: Record<string, string> = {
  LIMA: 'Lima',
  PROVINCIA: 'Provincia',
};

export const ESTADO_COTIZACION_LABELS: Record<string, string> = {
  BORRADOR: 'Borrador',
  ENVIADA: 'Enviada',
  ACEPTADA: 'Aceptada',
  RECHAZADA: 'Rechazada',
};

export const ESTADO_COLORS: Record<string, string> = {
  BORRADOR: 'bg-gray-100 text-gray-700',
  ENVIADA: 'bg-blue-100 text-blue-700',
  ACEPTADA: 'bg-green-100 text-green-700',
  RECHAZADA: 'bg-red-100 text-red-700',
};
